@if (productOverviewModel) {
  <div class="card-body-container">
    <p class="mat-body-medium">
      {{ productOverviewModel.description }}
    </p>
  </div>
}
